import { dev } from "@spectrum/shared-ng";

export const environment = {
    ...dev,
    CDN_BASE_URL: 'https://dev-cdn.seech.app/web',
}